export default function UnknownHost() {
    return (
        <>
            <p>We aren’t able to determine where you host your podcast from your RSS feed.</p>
            <p>
                <b>If you are self-hosted</b>, Podtrac measurement is supported. You can{" "}
                <a
                    href="https://podtrac.freshdesk.com/support/solutions/articles/48001184827-how-to-manually-add-the-podtrac-prefix-to-your-rss-feed"
                    target="_blank"
                >
                    view setup instructions here
                </a>.
            </p>

            <p>
                <b>If you are not self-hosted</b>, we can’t be sure if your podcast host is
                compatible with Podtrac. Contact your hosting provider and ask if they support
                Podtrac and if so how to implement Podtrac.
            </p>

            <p>
                <a href="https://podtrac.freshdesk.com/support/solutions" target="_blank">
                    Visit our knowledge base for more information
                </a>.
            </p>
        </>
    );
}
